export function toGlobalId(model, id) {
  return window.btoa(`${model}:${id}`);
}

export function fromGlobalId(id) {
  return window.atob(id).split(":")[1];
}

export function mapUUID(node) {
  if (!node) return null;
  return { ...node, id: node.uuid };
}

export default toGlobalId;
